import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import store from 'store';
import getRunnerUrl from '@/utils/getRunnerApiUrl';

const baseUrl = getRunnerUrl(window.location.href);

export const apiSlice = createApi({
	baseQuery: fetchBaseQuery({
		baseUrl,
		prepareHeaders: (headers, { getState }) => {
			// Retrieve the JWT token from your store (or localStorage, sessionStorage, etc.)
			const token = store.get('jwt');
			if (token) {
				// Set the Authorization header if the token exists
				headers.set('Authorization', `JWT ${token}`);
			}

			// You can also add any other headers here if needed
			return headers;
		},
	}),
	tagTypes: [
		'Quote',
		'Invoice',
		'Opportunity',
		'Job',
		'Customer',
		'User',
		'Project',
		'WorkflowEvent',
		'LineItem',
	],
	endpoints: (builder) => ({}),
});
